import { createApiSaga } from '../../../sagaGenerator';
import { apiGet } from '../../../../middleware/api';
import {
  GET_VOLCANO_EVENT_INFO_REQUEST,
  GET_VOLCANO_EVENT_INFO_SUCCESS,
  GET_VOLCANO_EVENT_INFO_FAILURE,
  GET_VOLCANO_EVENT_INFO_REFERENCES_REQUEST,
  GET_VOLCANO_EVENT_INFO_REFERENCES_SUCCESS,
  GET_VOLCANO_EVENT_INFO_REFERENCES_FAILURE,
} from './volcanoEventInfoReducer';

const getVolcanoEventInfoSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}/info`, ...action }),
  requestType: GET_VOLCANO_EVENT_INFO_REQUEST,
  successType: GET_VOLCANO_EVENT_INFO_SUCCESS,
  failureType: GET_VOLCANO_EVENT_INFO_FAILURE,
});

const getVolcanoEventReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}/references`, ...action }),
  requestType: GET_VOLCANO_EVENT_INFO_REFERENCES_REQUEST,
  successType: GET_VOLCANO_EVENT_INFO_REFERENCES_SUCCESS,
  failureType: GET_VOLCANO_EVENT_INFO_REFERENCES_FAILURE,
});

export const volcanoEventInfoSagas = [
  getVolcanoEventInfoSaga,
  getVolcanoEventReferencesSaga,
];
